<div class="quienes-somos mt-5 pt-5 pb-5">

  <div class="titulo">
    <app-titulo-descripcion titulo={{titulo}} descripcion={{descripcion}}></app-titulo-descripcion>
  </div>

  <div class="objetivos m-auto pt-5">
    <h2 class="subtitulo-a text-center mb-3">
      <i class="fas fa-lightbulb icono mr-2"></i>
      <strong class="text-dark">{{subtituloA}} </strong>
    </h2>

    <app-carta-img-izq *ngFor="let datos of datosObjetivos" imagen={{datos.imagen}} descripcion={{datos.descripcion}}
      imgTamano=1>
    </app-carta-img-izq>
  </div>

  <div class="avocados m-auto pt-5">
    <h2 class="subtitulo-b text-center mb-3">
      <i class="fas fa-hand-holding-heart icono mr-2"></i>
      <strong class="text-dark">{{subtituloB}} </strong>
    </h2>

    <app-carta-img-izq *ngFor="let datos of datosAvocados" imagen={{datos.imagen}} descripcion={{datos.descripcion}}
      imgTamano=2>
    </app-carta-img-izq>
  </div>
</div>
